import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getSuperbillTasks,
  getSuperbillTask,
  clearLocalSuperbillTasks,
  clearLocalActiveSuperbillTask
} from './actions';

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  superbillTask: { id: '', superbill_goal: null, result: null, status: '', updated_at: '' },
  loading: { all: false, superbillTask: false }
};

const slice = createSlice({
  name: 'superbillTasks',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getSuperbillTasks.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getSuperbillTasks.fulfilled, (state, action) => {
        const { superbill_tasks, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...superbill_tasks], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getSuperbillTasks.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getSuperbillTask.pending, (state) => {
        state.loading.superbillTask = true;
      })
      .addCase(getSuperbillTask.fulfilled, (state, action) => {
        const { superbill_task } = action.payload;
        const foundedSuperbillTask = !!_find(state.all.data, (s) => s.id === superbill_task.id);
        const updatedSuperbillTask = { ...state.superbillTask, ...superbill_task };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedSuperbillTask ? _map(state.all.data, (e) => e.id === superbill_task.id ? { ...e, ...superbill_task } : e) : [...[superbill_task], ...oldAllData]; 
        const pagination = foundedSuperbillTask ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.superbillTask = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedSuperbillTask) state.superbillTask = updatedSuperbillTask;       
      })
      .addCase(getSuperbillTask.rejected, (state) => {
        state.loading.superbillTask = false;
      })
      .addCase(clearLocalSuperbillTasks, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveSuperbillTask, state => {
        state.superbillTask = initialState.superbillTask;
      })
  }
})

export default slice.reducer;